import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

import { resetGroundTypeEffects } from 'services/API/Exploitation';
import { displayErrorMessage } from 'utils/tools_functions';
import { sendEvent } from 'utils/Event';

import DataGridGroundTypeEffects from '../Cooperative/DataGridGroundTypeEffects';
import { ThemeProvider } from '@mui/material/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import { customDialogTheme } from 'assets/styles/themes/Dialog/generic_dialog_mui';
import './groundTypeEffect.style.scss';
import useToggleSwitch from 'utils/hooks/useToggleSwitch';

const GroundTypeEffectsDataGridExploitation = ({
  exploitation,
  setExploitation,
  from,
  cultures,
  groundTypes,
}) => {
  const navigate = useNavigate();
  const [exploit, setExploit] = useState(exploitation);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const exploitId = exploit?.id ?? +localStorage.getItem('exploitation');

  const { isOrganic } = useToggleSwitch(
    from,
    'groundTypesEffects',
    () => {},
    exploitId,
    null,
    null
  );

  useEffect(() => {
    loadData();
    return () => {
      sendEvent('cancelHttpRequest');
    };
  }, []);

  const loadData = () => {
    if (localStorage.getItem('exploitation')) {
      setExploitation(isOrganic, +localStorage.getItem('exploitation'))
        .then((resp) => setExploit(resp.data.data))
        .catch((err) => toast.error(err.data));
    } else {
      toast.info('Selectionnez une exploitation');
      navigate('/exploitation');
    }
  };

  const resetAllGroundTypeEffects = () => {
    setOpenDeleteDialog(false);
    resetGroundTypeEffects(exploit, isOrganic)
      .then(() => {
        toast.success(`Effets ${exploit.name} réinitialisés`);
        setExploitation(isOrganic, exploitId);
      })
      .catch(() => toast.error(displayErrorMessage('ERR_REINIT_EFFECT')));
  };

  const renderDeleteDialog = () => {
    return (
      <ThemeProvider theme={customDialogTheme}>
        <Dialog maxWidth="md" open={openDeleteDialog}>
          <DialogTitle>Attention</DialogTitle>
          <DialogContent dividers>
            <h3>Remettre les valeurs par défaut</h3>
            <p>Réinitialiser les effets de type de sol de l'exploitation</p>
            <p>Souhaitez-vous continuer?</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={resetAllGroundTypeEffects}>
              Confirmer <DoneIcon />
            </Button>
            <Button onClick={() => setOpenDeleteDialog(false)}>
              Non <ClearIcon />
            </Button>
          </DialogActions>
        </Dialog>
      </ThemeProvider>
    );
  };

  const handleResetGroundTypeEffects = () => {
    setOpenDeleteDialog(true);
  };
  return (
    <>
      <DataGridGroundTypeEffects
        from={from}
        cultures={cultures?.data?.filter((culture) => culture.isCustomized === true)}
        ownerId={exploitId}
        refreshData={setExploitation}
        groundTypes={groundTypes}
        handleResetGroundTypeEffects={handleResetGroundTypeEffects}
      />
      {renderDeleteDialog()}
    </>
  );
};

export default GroundTypeEffectsDataGridExploitation;
